export default {
  init() {
    // JavaScript to be fired on the about us page

    // value item hover animation
    (function(){
      let $value_items = $('.value-item');

      $value_items.each(function(){
        let $that = $(this);
        let $desc = $(this).find('.description');
        let timer;

        $that
        .on('mouseenter', function(e) {
          e.stopPropagation();

          timer = setTimeout(function () {
            $desc.slideDown(); 
          }, 500);
        })
        .on('mouseleave', function(e) {
          e.stopPropagation();

          clearTimeout(timer);
          $desc.slideUp();
        });
      });
    })();


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js